/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LogReport } from '../../models/system/LogReport';
import { logmessage } from '../../models/system/logmessage';
import { IceTypes } from '../../models/icetypes';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private loggerSbj = new Subject<logmessage>();

  constructor() { }

  onLogger(ltype: IceTypes.LOGTYPE): Observable<logmessage> {
    return this.loggerSbj.asObservable().pipe(filter(lg => lg && lg.logtype === ltype || IceTypes.LOGTYPE.ltNone == ltype));
  }

  logger(report: any) {
    if (report == null) return;
    if (report.LOGS == null) return;

    let logs: any[] = report.LOGS;
    for (let il = 0; il < logs.length; il++) {
      this.loggerSbj.next(new logmessage(logs[il]));
    }
  }
}
